export default {
  APPOINTMENT: 'appointment',
  ITEM: 'item'
};
